var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 0C11.0212 0 7.20606 1.5803 4.39394 4.39394C1.5803 7.20606 0 11.0212 0 15C0 18.9788 1.5803 22.7939 4.39394 25.6061C7.20758 28.4197 11.0227 30 15 30C18.9773 30 22.7939 28.4197 25.6061 25.6061C28.4197 22.7924 30 18.9773 30 15C30 11.0227 28.4197 7.20606 25.6061 4.39394C22.7939 1.5803 18.9788 0 15 0ZM23.0242 9.30152L14.6909 20.9682C14.4061 21.3667 13.9606 21.6212 13.4712 21.6621C13.4242 21.6652 13.3788 21.6667 13.3333 21.6667C12.8909 21.6667 12.4667 21.4909 12.1545 21.1788L7.15455 16.1788C6.73939 15.7561 6.5803 15.1455 6.73485 14.5742C6.88939 14.003 7.33636 13.5576 7.90758 13.4015C8.47879 13.247 9.08939 13.4061 9.51212 13.8212L13.1212 17.4288L20.3106 7.36364C20.6561 6.87879 21.2348 6.61515 21.8273 6.67273C22.4197 6.7303 22.9379 7.09848 23.1833 7.64091C23.4303 8.18333 23.3697 8.81515 23.0227 9.3L23.0242 9.30152Z",
    fill: "#08B1F4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.a6542eb4cbbe4bc82f2c9da98df19c56.svg";
export { ForwardRef as ReactComponent };